module.exports = __webpack_public_path__ + "img/done.90a3feef.png";